import Vue from 'vue'

// 无法使用匿名函数 () => import('@/components/...')，因为第一次 this.$refs.dataTable 为 undefined
// Form
import LcFormButtonBar from '@/components/forms/LcFormButtonBar'
import BoolCheckbox from '@/components/forms/BoolCheckbox'
import CheckAll from '@/components/forms/CheckAll'
import Checkbox from '@/components/forms/Checkbox'
import EditableText from '@/components/EditableText'
import ImgCropper from '@/components/ImgCropper'
import LcDateRangePicker from '@/components/searchs/LcDateRangePicker'
import LcDateRangeSearch from '@/components/searchs/LcDateRangeSearch'
import LcExportButton from '@/components/buttons/LcExportButton'
import LcFiltersDisplayWidget from '@/components/searchs/LcFiltersDisplayWidget'
import LcCellText from '@/components/LcCellText'
import LcNumberRange from '@/components/forms/LcNumberRange'
import LcUser from '@/components/LcUser.vue'
import LcSwitch from '@/components/LcSwitch.vue'
import LcServiceProvider from '@/components/LcServiceProvider.vue'
import LcNavBack from '@/components/layouts/LcNavBack'
import LcPanel from '@/components/layouts/LcPanel'
import LcSummaryPanel from '@/components/layouts/LcSummaryPanel'
import LcSummaryItem from '@/components/layouts/LcSummaryItem'
import LcSummarySubItem from '@/components/layouts/LcSummarySubItem'
import LcPage from '@/components/layouts/LcPage'
import Radio from '@/components/forms/Radio'
import SearchInput from '@/components/searchs/SearchInput'
import SecretText from '@/components/layouts/SecretText'
import SvgIcon from '@/components/SvgIcon'
import TagsEditor from '@/components/TagsEditor'
import XlsExportButton from '@/components/buttons/XlsExportButton'
import LcPagination from '@/components/tables/LcPagination.vue'
import GoToStationOrCharger from '@/components/GoToStationOrCharger.vue'
import LcNumPadding from '@/components/LcNumPadding.vue'

// Form
Vue.component('lc-form-button-bar', LcFormButtonBar)
Vue.component('bool-checkbox', BoolCheckbox) // 待移除
Vue.component('check-all', CheckAll) // 待移除(OpenAPI权限在用)
Vue.component('checkbox', Checkbox) // 待移除
Vue.component('editable-text', EditableText)
Vue.component('img-cropper', ImgCropper) // 图片裁剪工具
Vue.component('lc-date-range-picker', LcDateRangePicker)
Vue.component('lc-date-range-search', LcDateRangeSearch)
Vue.component('lc-export-button', LcExportButton)
Vue.component('lc-filters-display-widget', LcFiltersDisplayWidget)
Vue.component('lc-cell-text', LcCellText)
Vue.component('lc-number-range', LcNumberRange)
Vue.component('lc-user', LcUser)
Vue.component('lc-switch', LcSwitch)
Vue.component('lc-service-provider', LcServiceProvider)
Vue.component('lc-nav-back', LcNavBack)
Vue.component('lc-panel', LcPanel)
Vue.component('lc-summary-panel', LcSummaryPanel)
Vue.component('lc-summary-item', LcSummaryItem)
Vue.component('lc-summary-sub-item', LcSummarySubItem)
Vue.component('lc-page', LcPage)
Vue.component('radio', Radio) // 待删除
Vue.component('search-input', SearchInput) // 关键词搜索组件
Vue.component('secret-text', SecretText)
Vue.component('svg-icon', SvgIcon) // 待删除
Vue.component('tags-editor', TagsEditor)
Vue.component('xls-export-button', XlsExportButton) // 待移除（还有几个列表在使用，需要重构API）
Vue.component('lc-pagination', LcPagination)
Vue.component('go-to-station-or-charger', GoToStationOrCharger)
Vue.component('lc-num-padding', LcNumPadding)
